import { questionsSchema } from "@/pages/service_quote_flow/utils/qna-tree";
import { deserializeQueryParams } from "@/utils/network";
import { z } from "zod";

// FIXME: this should probably come from backend inside the tree or outside
export const HOME_BIZ_QUESITON_ID = 581;
export function getWindowData() {
  const DEFAULT_SOURCE_ID = "22";
  const tcpaText = window.tcpa_text ?? "";
  const preferenceTo = window.preference_to;
  const schema = z.object({
    // service_info should be guarenteed to existed
    service_info: z.object({
      id: z.number(),
      name: z.string(),
      display_name: z.string(),
      contractors: z.string().nullish(),
    }),
    // we should be able to function and fall back without/partial homeowner_info
    homeowner_info: z.object({
      f_name: z.string(),
      n_phone: z.string(),
      address: z.string(),
      email: z.string().nullish(),
      zip: z.string()
    }).partial().nullish(),
  });


  const parsed = schema.parse({
    service_info: window.service_info,
    homeowner_info: window.homeowner_info,
  });

  const queryParams = deserializeQueryParams(window.location.search.substring(1));
  const queryParamsSourceId = z.string().safeParse(queryParams.source_id).success ? queryParams.source_id as string : undefined;
  const sourceId = queryParamsSourceId || DEFAULT_SOURCE_ID;

  const queryParamsZip = z.string().safeParse(queryParams.zip).success ? queryParams.zip as string : undefined;
  const defaultLocation = window.default_location ?? { zip: queryParamsZip };

  const defaultZipSource: "search" | "window" | "none" = queryParamsZip ? "search" : window.default_location?.zip ? "window" : "none";

  return {
    questions_tree: questionsSchema.parse(window.questions_tree),
    service_info: parsed.service_info,
    homeowner_info: parsed.homeowner_info,
    preferenceTo,
    defaultLocation,
    defaultZipSource,
    tcpaText,
    sourceId,
  }
}
